<template>
    <el-table
        class="table w-100"
        max-height="270"
        stripe
        :data="data"
        v-loading="isLoading">
        <!-- @row-click="selectCompany"> -->
        <el-table-column
            label="Company"
            prop="company.name"
            fixed>
        </el-table-column>
        <el-table-column
            label="Responsible"
            fixed>
            <template v-slot="scope">
                {{ scope.row.user?.first_name }} {{ scope.row.user?.last_name }}
            </template>
        </el-table-column>
        <el-table-column
            label="KYC Filled"
            prop="company.kyc_filled"
            sortable
            fixed>
            <template v-slot="scope">
                {{ scope.row.company.kyc_filled ? 'Yes' : 'No' }}
            </template>
        </el-table-column>
        <el-table-column
            label="Trial days remaining"
            prop="company.subscription.trial_start"
            sortable
            fixed>
            <template v-slot="scope">
                {{ calculateTrialDaysRemaining(scope.row.company) }}
            </template>
        </el-table-column>
        <el-table-column
            label="Account Created on"
            prop="created_at"
            sortable
            fixed>
            <template v-slot="scope">
                {{ scope.row.created_at | fixFullDateLocal }}
            </template>
        </el-table-column>
        <el-table-column
            label="Status"
            prop="status"
            width="320"
            sortable
            fixed>
            <template v-slot="scope">
                <div class="d-flex align-items-center">
                    <div class="status-badge"
                            :class="[`status-badge-${parseStatusValue(scope.row.company.kyc_status)}`]">
                    </div>
                    <div class="ml-2">
                        {{ parseStatus(scope.row.company.kyc_status) }}
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="Aloware Admin User"
            width="300"
            fixed>
            <template v-slot="scope">
                {{ scope.row?.admin?.first_name }} {{ scope.row?.admin?.last_name }}
            </template>
        </el-table-column>
        <!-- <el-table-column
            label="Reviewed by"
            prop="reviewed_by"
            width="220"
            fixed>
        </el-table-column> -->
        <el-table-column
            fixed>
            <template v-slot="scope">
                <div class="d-flex justify-content-center link"
                     @click="selectCompany(scope.row)">
                    See More
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { kyc_mixin } from '../../mixins'
export default {
    name: "KycReviewLogTable",

    mixins: [
        kyc_mixin
    ],

    props: {
        data: {
            type: Array,
            required: true
        },

        parseStatus: {
            type: Function,
            required: true
        },

        parseStatusValue: {
            type: Function,
            required: true
        },

        isLoading: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        selectCompany(row) {
            this.$emit('select-company', row)
        }
    }
}
</script>
